import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Text } from "@fragments";

// Resolved at render so the abbreviations follow the active language.
const getMonths = (t) => [
  t("membersList.monthsShort.jan"),
  t("membersList.monthsShort.feb"),
  t("membersList.monthsShort.mar"),
  t("membersList.monthsShort.apr"),
  t("membersList.monthsShort.may"),
  t("membersList.monthsShort.jun"),
  t("membersList.monthsShort.jul"),
  t("membersList.monthsShort.aug"),
  t("membersList.monthsShort.sep"),
  t("membersList.monthsShort.oct"),
  t("membersList.monthsShort.nov"),
  t("membersList.monthsShort.dec"),
];

function formatJoinedDate(raw, months) {
  if (!raw) return null;
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return null;
  const day = String(date.getDate()).padStart(2, "0");
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
}

export default function MemberSinceCell({ member }) {
  const { t } = useTranslation("memberModals");

  const months = useMemo(() => getMonths(t), [t]);

  const joined = member?.timestamps?.joined || member?.timestamps?.created;
  const formatted = formatJoinedDate(joined, months);

  return (
    <Text.span contrast={4}>
      {formatted || "—"}
    </Text.span>
  );
}
